// extracted by mini-css-extract-plugin
export var logo = "Testimonials-module--logo--SH2qP";
export var logoMark = "Testimonials-module--logoMark--5MwLD";
export var testimonials = "Testimonials-module--testimonials--fGmLX";